import React from 'react';
import { Plate } from '../shared/ui/Page';
import LoaderComponent from '../shared/Loader';
import { Header24h34, MonthPlate, MonthWrap } from './styles';
import Spacer from '../shared/Spacer';
import { Item, Props as ItemProps } from 'features/webinars/item';
import { Tab } from './useWebinarStore';

interface Props {
  activeTab: Tab;
  setTab: (value: Tab) => void;
  loaded: boolean;
  months: Tab[];
  webinarsInMonth: ItemProps[];
}
const Schedule = ({ activeTab, setTab, loaded, months, webinarsInMonth }: Props) => {
  return (
    <Plate data-qa-id="webinar_schedule">
      <Header24h34>Расписание вебинаров на {activeTab.label.toLowerCase()}</Header24h34>
      <Spacer size={48} />
      <MonthWrap>
        {months.map((el) => (
          <MonthPlate state={el.id === activeTab.id ? 'selected' : 'available'} onClick={() => setTab(el)}>
            {el.label}
          </MonthPlate>
        ))}
      </MonthWrap>

      <Spacer size={40} />
      {loaded ? (
        <>
          {webinarsInMonth.map((i) => (
            <Item {...i} />
          ))}
        </>
      ) : (
        <LoaderComponent />
      )}
    </Plate>
  );
};

export default Schedule;
